import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_FlowService } from './Utilities.flow.index';

import { Totes_create_delete_or_update_container_statusesService } from './Totes.flow.index';
import { Totes_create_delete_or_update_containersService } from './Totes.flow.index';
import { Totes_induct_toteService } from './Totes.flow.index';
import { Totes_totinizationService } from './Totes.flow.index';

import { $frontendTypes } from './Totes.frontend.types'

@Injectable({ providedIn: 'root' })
export class Totes_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_FlowService);
  }

    public Utilities: Utilities_FlowService;
  public Totes: Totes_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _create_delete_or_update_container_statuses: Totes_create_delete_or_update_container_statusesService;
  public async create_delete_or_update_container_statuses($inParams: { statusId?: number, status_name?: string, action?: string }): Promise< { reasons?: string[] }> {
    if(!this._create_delete_or_update_container_statuses) { 
      this._create_delete_or_update_container_statuses = this.injector.get(Totes_create_delete_or_update_container_statusesService);
    }
    return this._create_delete_or_update_container_statuses.run($inParams);
  }
   
   

   
 
  private _create_delete_or_update_containers: Totes_create_delete_or_update_containersService;
  public async create_delete_or_update_containers($inParams: { statusId?: number, container_type_id?: number, lookup?: string, warehouse_id?: number, action?: string, container_id?: number }): Promise< { reasons?: string[] }> {
    if(!this._create_delete_or_update_containers) { 
      this._create_delete_or_update_containers = this.injector.get(Totes_create_delete_or_update_containersService);
    }
    return this._create_delete_or_update_containers.run($inParams);
  }
   
   

   
 
  private _induct_tote: Totes_induct_toteService;
  public async induct_tote($inParams: { tote_lookup_code?: string, warehouseId?: number, container_type_id?: number, transaction_id?: string }): Promise< { reasons?: string[], toteGroupingId?: number }> {
    if(!this._induct_tote) { 
      this._induct_tote = this.injector.get(Totes_induct_toteService);
    }
    return this._induct_tote.run($inParams);
  }
   
   

   
 
  private _totinization: Totes_totinizationService;
  public async totinization($inParams: { waveTasks?: $frontendTypes.Totes.waveTasks[], weightCapacity?: number, dimFactor?: number }): Promise< { groupedTotes?: { toteGroup: number, waveTasks: $frontendTypes.Totes.waveTasks[] }[] }> {
    if(!this._totinization) { 
      this._totinization = this.injector.get(Totes_totinizationService);
    }
    return this._totinization.run($inParams);
  }
   
   

   
}
